import request from '@/_util/require';

const version = 'v1';
const prefix = `/${version}/waper/erp/pc/ai/statistics`;

/** 账号统计（分页） */
export async function getAiAccountStatisticsPage(data) {
  return request(`${prefix}/getaiaccountstatisticspage`, {
    method: 'POST',
    data,
  });
}

/** 错误率排行统计 */
export async function getAiErrorRankStatistics() {
  return request(`${prefix}/getaierrorrankstatistics`, {
    method: 'GET',
  });
}

/** 总数统计 */
export async function getAiTotalCountStatistics() {
  return request(`${prefix}/getaitotalcountstatistics`, {
    method: 'GET',
  });
}

/** 周趋势统计 */
export async function getAiWeekTrendStatistics() {
  return request(`${prefix}/getaiweektrendstatistics`, {
    method: 'GET',
  });
}
